export function getBatchStatus (batch, taskSummary) {
  if (!batch) return { label: 'Unknown', className: '', icon: 'help', iconColor: 'gray' }
  if (batch.isCancelled) return { label: 'Cancelled', className: 'errored', icon: 'close', iconColor: 'gray' }
  if (batch.isError) return { label: 'Failed', className: 'errored', icon: 'close', iconColor: 'red' }
  if (batch.isProcessing) return { label: 'Processing', className: 'processing', icon: 'sync', iconColor: 'var(--color-primary-500)' }
  if (batch.lastFinishedDate) return { label: 'Completed', className: 'complete', icon: 'check', iconColor: 'green' }
  const total = taskSummary?.total ?? batch.taskSummary?.total ?? 0
  if (total > 0) return { label: 'Ready', className: 'idle', icon: 'playArrow', iconColor: 'orange' }
  return { label: 'Pending', className: 'idle', icon: 'schedule', iconColor: 'gray' }
}
